import type { Me } from "@shared/api"
import { AppShell } from "./components/TopBar"
import { AuthGate } from "./components/AuthGate"
import { AuthProvider } from "./context/AuthContext"
import { ViewTabs, type DashboardView } from "./components/ViewTabs"
import { useQueryState } from "./hooks/useQueryState"
import { OvertimePage } from "./pages/OvertimePage"
import { RequestsPage } from "./pages/RequestsPage"

/**
 * Dos vistas, elegidas por `?view=` — sigue sin haber router ni Suspense, por las
 * razones de useQueryState (el path nunca cambia, el hash es de Supabase).
 *
 * useQueryState SE INSTANCIA UNA SOLA VEZ, acá, y baja por props (QueryStateApi
 * explica por qué dos instancias se pisarían la URL). `month` y `department`
 * comparten clave entre las dos vistas a propósito: cambiar de pestaña conserva
 * el mes y el filtro elegidos.
 */
function Dashboard({ me }: { me: Me }) {
  const { query, setQuery } = useQueryState()
  // Basura o ausencia en ?view= → la vista por persona, sin estados raros: misma
  // tolerancia que el clamp del mes en las páginas.
  const view: DashboardView = query.view === "requests" ? "requests" : "people"

  return (
    <AppShell
      me={me}
      wide={view === "requests"}
      nav={
        <ViewTabs
          view={view}
          // undefined borra la clave (ver useQueryState): la vista default deja
          // la URL igual que si nunca se hubiera navegado.
          onChange={(v) => setQuery({ view: v === "people" ? undefined : v })}
        />
      }
    >
      {view === "requests" ? (
        <RequestsPage query={query} setQuery={setQuery} />
      ) : (
        <OvertimePage query={query} setQuery={setQuery} />
      )}
    </AppShell>
  )
}

export function App() {
  return (
    <AuthProvider>
      <AuthGate>{(me) => <Dashboard me={me} />}</AuthGate>
    </AuthProvider>
  )
}
